<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/q9HMy5/media/FC-9781398455917.jpg?1708093998516" alt="This image is the cover for the book On the Bible's Back Roads"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">On the Bible's Back Roads
      </h1>
      <p class="bookDescription body article font2">
        <p>The Bible contains many stories of what might be called ‘bit players’; those who appear briefly, sometimes only for a few verses, and are not central to the narrative, but who still play a significant role. These old stories feature and were written by people with whom we share a common humanity and whose encounters with God have much to teach us. In their stories we see something of our own stories and, if we listen aright, we can hear the divine voice speaking through their strength and weaknesses, their triumphs and tragedies and their joys and sorrows. Their stories also throw light on the heart of the narrative, the story of Jesus, and demonstrate the rich inclusiveness of the Bible. They also offer us a fascinating reflection of who we are as Christian believers and the nature of the world in which we try to live out our faith. Their journeys, however marginal they may seem, make significant contributions to the story Scripture tells. This book can be used generally by individuals or groups but is also suitable for use as a series of Lenten reflections. As we listen to some of the lesser-known voices and stories we encounter in Scripture we will find that they are not there by accident and have the power to profoundly enrich our Christian understanding.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Green
      </h2>
      
      <p class="authorDescription body article">Rob Green studied theology at King’s College, London, and trained for ordained ministry in the Church of England at Wycliffe Hall, Oxford. He spent over thirty years in parish ministry mostly on the staff of Norbury Parish Church, Hazel Grove. For nine of those years he also trained Readers (lay ministers) in the Diocese of Chester. He retired in 2019 but continues to write and blogs at revrobgreen.wordpress.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42348eba